export type Coords = { lat: number; lng: number; accuracy?: number };

export async function getCurrentCoordinates(timeoutMs = 12000): Promise<Coords> {
  if (!("geolocation" in navigator)) {
    throw new Error("Geolocation not supported in this browser.");
  }

  return new Promise<Coords>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;
        resolve({ lat: latitude, lng: longitude, accuracy });
      },
      (err) => {
        // Optional: wrap with clearer messages
        let message = "Unknown geolocation error";
        if (err.code === 1) message = "Permission denied";
        else if (err.code === 2) message = "Position unavailable";
        else if (err.code === 3) message = "Geolocation timeout";

        reject(new Error(message));
      },
      {
        enableHighAccuracy: true,
        timeout: timeoutMs,
        maximumAge: 60_000, // allow cached fixes up to 1 min old (tweakable)
      }
    );
  });
}

